export const isCellphoneValid = (fullphone) => {
	return fullphone?.length == 10;
};

export const formHasError = (formData) => {
	let message = false;

	if (
		!String(formData.correo)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			)
	) {
		message = "Ingresa un email válido";
	}
	if (formData.inscripcion.participantes?.length === 0) {
		message = "Agrega al menos un hijo";
	}

	return message;
};
